/**
 * Maps Auth0 SDK / callback errors to actionable pt-BR messages.
 */
export function formatAuth0Error(error: unknown): string {
  const message = extractMessage(error);

  if (
    message.includes('not authorized to access resource server') ||
    message.includes('nao esta autorizado a acessar o resource server')
  ) {
    return (
      'A aplicação web não está autorizada a usar a API yHelp no Auth0. ' +
      'No dashboard: Applications → yHelp Web → aba APIs → autorize "yHelp API".'
    );
  }

  if (message.includes('Callback URL mismatch') || message.includes('redirect_uri')) {
    return (
      'URL de callback não permitida. Adicione http://localhost:5173/callback em ' +
      'Allowed Callback URLs da aplicação SPA no Auth0.'
    );
  }

  if (message.includes('login_required') || message.includes('consent_required')) {
    return 'Sessão expirada. Clique em Login novamente.';
  }

  if (message) {
    return message;
  }

  return 'Falha ao iniciar login. Tente novamente.';
}

function extractMessage(error: unknown): string {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (error instanceof Error) return error.message;
  if (typeof error === 'object' && error !== null) {
    const obj = error as { message?: string; error_description?: string; error?: string };
    return obj.error_description ?? obj.message ?? obj.error ?? '';
  }
  return String(error);
}
